/** "AORTIC_STENOSIS" → "AS", "FOLLOW_UP_RECOMMENDED_3_MONTHS" → "FUR3M" */
export function abbreviateTag(tag: string): string {
  return tag
    .split('_')
    .map((word) => (/^\d+$/.test(word) ? word : word.charAt(0)))
    .join('');
}

/** "AORTIC_STENOSIS" → "Aortic Stenosis" */
export function formatTagLabel(tag: string): string {
  return tag
    .split('_')
    .map((word) => {
      if (/^\d+$/.test(word)) return word;
      return word.charAt(0) + word.slice(1).toLowerCase();
    })
    .join(' ');
}
